/**
 * Browser Detection Singleton
 *
 * For detecting browser to handle browser specific issues.
 */
class GMXBrowserDetectSingleton {
	constructor() {
		if (!window.browserDetectSingleton) {
			window.browserDetectSingleton = this
		}
	}

	/**
	 * Method to detect if the user is on a mobile device and to identify the browser being used.
	 *
	 * @returns {{ isMobile: boolean, browser: string }} An object containing a boolean indicating if the user is on a mobile device and a string indicating the browser name.
	 */
	public detectBrowserOrMobile(): { isMobile: boolean, browser: string } {
		// @ts-expect-error:  window.opera is not standard but is used in OPERA browser detection
		const userAgent = navigator.userAgent || navigator.vendor || window.opera

		// Detect mobile devices
		const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase())

		// Detect browsers
		let browser = 'Unknown'
		if (userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Edg') === -1) {
			browser = "Chrome"
		} else if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
			browser = "Safari"
		} else if (userAgent.indexOf('Firefox') > -1) {
			browser = "Firefox"
		} else if (userAgent.indexOf('Edg') > -1) {
			browser = "Edge"
		}

		return {
			isMobile,
			browser,
		}
	}

	/**
	 * Method to set a CSS variable for scrollbar width offset to prevent layout shifts when scrollbars appear/disappear, applied only for non-mobile devices.
	 */
	public setScrollbarWidthOffset(): void {
		const result = this.detectBrowserOrMobile()

		if (!result.isMobile && document.documentElement.clientWidth < window.innerWidth) {
			const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth

			document.documentElement.style.setProperty('--document-scrollbar-width', `${scrollbarWidth}px`)
		} else {
			document.documentElement.style.removeProperty('--document-scrollbar-width')
		}
	}
}

const browserDetectSingleton = Object.freeze(new GMXBrowserDetectSingleton())
export default browserDetectSingleton
